import { API, axios, SendRequest, toastr} from '@/imports-files/pages/clients/activities/integration-connected';


export class IntegrationConnect extends SendRequest {
  async submitIntegrationCode(params, slug, client_slug){
    const url = API.client.activities.SEND_INTEGRATION_CODE.replace('$slug', slug);
    try {
      const result = await axios.post( url,
          params,
          this.setCustomHeaderJSON(client_slug),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
